import React from 'react'
import { AiFillEdit } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { DataGrid, GridToolbar, GridActionsCellItem } from '@mui/x-data-grid';
import useArge from '../../hooks/useArge';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material'

const HammaddeHazirlama_DataTable = ({ hammaddeHazirlama, setInfo, info, delHandleOpen, handleOpen, filterModel, setFilterModel }) => {


    const [presData, setpresData] = useState([])

    const dataGrid_Columns = [
        // {
        //     field: "id",
        //     headerName: "ID",
        //     minWidth: 150,
        //     headerAlign: "center",
        //     align: "center",
        //     flex: 1,
        // },
        {
            field: "actions",
            headerName: "#",
            minWidth: 120,
            headerAlign: "center",
            align: "center",
            flex: 1,
            renderCell: ({ id,
                row: {
                    is_merkezi,
                    urun_kodu,
                    oldData_date,
                    granulNemOrani,
                    besyuzMikron,
                    dortyuzMikron,
                    ucyuzonbesMikron,
                    ikiyuzMikron,
                    lessthanyuzMikron,
                    granulAkisi,
                    granulYogunluk,
                    mikserSicaklik,
                    mikserYogunluk,
                    viskozite_t1,
                    viskozite_t2,
                    tiksotropi_t1t2,
                    uygunsuzluktipi,
                    aciklama,
                    vardiyasorumlusu,
                    sirlamaTankiSicaklik,
                    sirlamaTankiYogunluk,
                    viskozite_g1,
                    viskozite_g2,
                    tiksotropi_g1g2,
                    ph,
                } }) => {
                return [
                    <GridActionsCellItem
                        key={"edit"}
                        icon={<AiFillEdit size={25} style={{ color: '#0802A3' }} cursor='pointer' />}
                        label="Edit"
                        onClick={() => {
                            handleOpen()
                            setInfo({
                                id,
                                type: 'HammaddeHazirlama',
                                is_merkezi,
                                urun_kodu,
                                oldData_date,
                                granulNemOrani,
                                besyuzMikron,
                                dortyuzMikron,
                                ucyuzonbesMikron,
                                ikiyuzMikron,
                                lessthanyuzMikron,
                                granulAkisi,
                                granulYogunluk,
                                mikserSicaklik,
                                mikserYogunluk,
                                viskozite_t1,
                                viskozite_t2,
                                tiksotropi_t1t2,
                                uygunsuzluktipi,
                                aciklama,
                                vardiyasorumlusu,
                                sirlamaTankiSicaklik,
                                sirlamaTankiYogunluk,
                                viskozite_g1,
                                viskozite_g2,
                                tiksotropi_g1g2,
                                ph,
                            })
                        }}

                    />,
                    <GridActionsCellItem
                        key={"delete"}
                        icon={<MdDelete size={25} style={{ color: '#D80032' }} cursor='pointer' />}
                        label="Delete"
                        onClick={() => {
                            delHandleOpen()
                            setInfo({ id, type: 'HammaddeHazirlama' })
                        }}

                    />,
                ]
            },
        },
        {
            field: "date",
            headerName: "Tarih",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "time",
            headerName: "Saat",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "vardiya",
            headerName: "Vardiya",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "kontroleden_kisi",
            headerName: "Kontrol Yapan",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "is_merkezi",
            headerName: "İş Merkezi",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "urun_kodu",
            headerName: "Ürün Kodu",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "granulNemOrani",
            headerName: "granulNemOrani",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "besyuzMikron",
            headerName: "besyuzMikron",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "dortyuzMikron",
            headerName: "dortyuzMikron",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "ucyuzonbesMikron",
            headerName: "ucyuzonbesMikron",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "ikiyuzMikron",
            headerName: "ikiyuzMikron",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "yuzMikron",
            headerName: "yuzMikron",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "lessthanyuzMikron",
            headerName: "<100 Mikron",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "granulAkisi",
            headerName: "granulAkisi",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "granulYogunluk",
            headerName: "granulYogunluk",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "mikserSicaklik",
            headerName: "mikserSicaklik",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "mikserYogunluk",
            headerName: "mikserYogunluk",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "viskozite_t1",
            headerName: "viskozite_t1",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "viskozite_t2",
            headerName: "viskozite_t2",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "Tiksotropi_t1t2",
            headerName: "Tiksotropi_t1t2",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "sirlamaTankiSicaklik",
            headerName: "Sırlama Tanki Sicaklik",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "sirlamaTankiYogunluk",
            headerName: "Sırlama Tanki Yogunluk",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "viskozite_g1",
            headerName: "viskozite_g1",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "viskozite_g2",
            headerName: "viskozite_g2",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "tiksotropi_g1g2",
            headerName: "tiksotropi_g1g2",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "ph",
            headerName: "ph",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "uygunsuzluktipi",
            headerName: "Uygunsuzluk Tipi",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "aciklama",
            headerName: "Açıklama",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },
        {
            field: "vardiyasorumlusu",
            headerName: "Vardiya Sorumlusu",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
        },


    ];


    useEffect(() => {
        const dizi = Object.keys(hammaddeHazirlama).map(key => { return { id: key, ...hammaddeHazirlama[key] } })
        dizi.sort((a, b) => {
            const convertDateTime = (date, time) => {
                if (!date || !time) {
                    // Eğer date veya time undefined veya boş string ise, geçerli bir tarih döndürmeyebilir.
                    // Bu durumu ele almak için bir alternatif dönüş değeri sağlayabilirsiniz.
                    // Örneğin, çok geçmiş veya gelecek bir tarih olabilir.
                    // Burada örnek olarak Unix Epoch başlangıcını kullanıyoruz.
                    return new Date(0); // 1 Ocak 1970
                }
                const [day, month, year] = date.split('-').map(num => num.padStart(2, '0'));
                const [hours, minutes] = time.split(':').map(num => num.padStart(2, '0'));
                return new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
            };

            const dateTimeA = convertDateTime(a.date, a.time);
            const dateTimeB = convertDateTime(b.date, b.time);


            return dateTimeB - dateTimeA;
        })
        setpresData(dizi)
    }, [hammaddeHazirlama])



    const handleFilterChange = (newFilterModel) => {
        setFilterModel(newFilterModel);
        // Burada filtrelenmiş olan satırları `newFilterModel` ile kontrol edebilirsiniz
    };


    return (


        <DataGrid
            columns={dataGrid_Columns}
            rows={presData}
            initialState={{
                pagination: {
                    paginationModel: {
                        pageSize: 10,
                    },
                },
            }}
            pageSizeOptions={[10, 25, 50, 75, 100]}
            slots={{ toolbar: GridToolbar }}
            disableRowSelectionOnClick
            sx={{
                boxShadow: 4,
            }}
            filterModel={filterModel}
            onFilterModelChange={handleFilterChange}
        />



    )
}

export default HammaddeHazirlama_DataTable